import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark as faBookmarkSolid } from "@fortawesome/free-solid-svg-icons";
import { toggleMentorBookmark } from "../../stores/bookmarks/mentorBookmarksSlice";
import "./CardStyles.css";
import { Mentor } from "../../pages/Mentorpal/MentorPal";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";

export interface CardProps {
  mentor: Mentor;
  isMentorsPage: boolean;
  onClick: () => void;
}

const Card = ({
  mentor,
  isMentorsPage,
  onClick,
}: CardProps) => {
  const { _id, name, title, thumbnail } = mentor;
  const dispatch = useAppDispatch();

  const { userId, sessionId } = useAppSelector(
    (state) => state.session
  );
  const bookmarkedMentors = useAppSelector(
    (state) => state.mentorBookmarks.bookmarks
  );

  const isBookmarked = bookmarkedMentors.some((mentor) => mentor.mentorId === _id);

  const handleBookmark = (e) => {
    e.stopPropagation();

    if (!name) {
      console.warn("⚠️ Bookmark skipped due to missing ID.");
      return;
    }

    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "Mentor", name, {});
    sendEvent(eventData);

    dispatch(
      toggleMentorBookmark({
        userId, mentorId: _id
      })
    );
  };

  const handleCardClick = (e) => {
    if (!e.target.closest(".card-bookmark-button")) {
      onClick && onClick();
    }
  };

  return (
    <div
      className={`card ${isMentorsPage ? "card-mentors-page" : ""}`}
      onClick={handleCardClick}
    >
      <p className="card-title">{name}</p>
      <div className="card-link">
        <img src={thumbnail} alt={title} className="card-thumbnail" />
      </div>
      <h3 className="card-subtitle">{title}</h3>

      <button
        data-cy="bookmark-card"
        onClick={handleBookmark}
        className="card-bookmark-button"
        aria-label={isBookmarked ? "Remove Bookmark" : "Add Bookmark"}
      >
        <FontAwesomeIcon
          //icon={isBookmarked ? faBookmarkSolid : faBookmark}
          icon={isBookmarked ? faBookmarkSolid : faBookmarkSolid}
          className={`card-bookmark-icon ${isBookmarked ? "blue" : "white"}`}
        />
      </button>
    </div>
  );
};

export default Card;
